import {
    AddLargeIcon, DeliveryIcon,
    FoodTruckIcon, QuickIcon,
    KDSNewIcon, KioskStandingIcon,
    OnlineStoreIcon, POSIcon,
    QRCodeIcon, SpeakerIcon,
    AllBoxIcon, ChatIcon,
    GiftIcon, CafeIcon,
} from "../../assets/icon";
import img01 from '../../assets/image/dummy-images/dummy11.png'
import img02 from '../../assets/image/dummy-images/dummy12.png'
import img03 from '../../assets/image/dummy-images/dummy13.png'
import img04 from '../../assets/image/dummy-images/dummy14.png'
import img05 from '../../assets/image/dummy-images/dummy15.png'
import img06 from '../../assets/image/dummy-images/dummy16.png'

export const dataArraySuits = [
    {
        icon: <KioskStandingIcon />,
        text: "Revi Self-Service System",
        tipimg: [img01],
        tiptext: "Revi Self-Service System",
        tiptext02: "Serve more customers by using the Revi Self-Service Kiosk. Choose between our standing kiosk or clamp kiosk."
    },
    {
        icon: <POSIcon />,
        text: "Revi Staff-Led Ordering",
        tipimg: [img02],
        tiptext: "Revi Staff-Led Ordering",
        tiptext02: "Enhance your staff's ability to drive more revenue through intelligent upsells and consumer profile data. "
    },
    {
        icon: <KDSNewIcon />,
        text: "Revi Kitchen Display Tablet (KDS)",
        tipimg: [img03],
        tiptext: "Revi Kitchen Display Tablet (KDS)",
        tiptext02: "Seamlessly Consolidate all your in-store, online orders & delivery carriers onto one tablet for your kitchen staff's convenience. "
    },
    {
        icon: <OnlineStoreIcon />,
        text: "Revi Online Store",
        tipimg: [img04],
        tiptext: "Revi Online Store",
        tiptext02: "Drive customers to your website to purchase, while building a valuable customer list. Customized menus with beautiful photos of your food. "
    },
    {
        icon: <DeliveryIcon />,
        text: "Revi Delivery",
        tipimg: [],
        tiptext: "Revi Delivery",
        tiptext02: "0% commissions for online ordering(Delivery, Pickup, QR Codes) flat fee delivery vs 30% with Doordash."
    },
    {
        icon: <QRCodeIcon />,
        text: "Revi QR Code Integration",
        tipimg: [img05],
        tiptext: "Revi QR Code Integration",
        tiptext02: "Connect your customers directly to purchase from your online store through posters, delivery flyers, coasters and table tents."
    },
    {
        icon: <AllBoxIcon />,
        text: "Revi Order Consolidation",
        tipimg: [],
        tiptext: "Revi Order Consolidation",
        tiptext02: "Seamlessly consolidate all your online orders and delivery carriers onto one tablet for your kitchen staff's convenience."
    },
    {
        icon: <SpeakerIcon />,
        text: "Revi Marketing",
        tipimg: [],
        tiptext: "Revi Marketing",
        tiptext02: "Engage directly with your customer list through personalized and automated text messaging campaigns to drive more sales for your business, as well as promote new menu items, events, and more!"
    },
    {
        icon: <ChatIcon />,
        text: "Revi Support, Shipping, and Setup",
        tipimg: [],
        tiptext: "Revi Support, Shipping, and Setup",
        tiptext02: "Revi Support and Partner Success teams will guide you through the setup process, get your online store up and running and are happy to help answer any technical questions along the way."
    }
]

export const dataArrayDigital = [
    {
        icon: <OnlineStoreIcon />,
        text: "Revi Online Store",
        tipimg: [img04],
        tiptext: "Revi Online Store",
        tiptext02: "Drive customers to your website to purchase, while building a valuable customer list. Customized menus with beautiful photos of your food."
    },
    {
        icon: <ChatIcon />,
        text: "Revi Support, Shipping, and Setup",
        tipimg: [],
        tiptext: "Revi Support, Shipping, and Setup",
        tiptext02: "Revi Support and Partner Success teams will guide you through the setup process, get your online store up and running and are happy to help answer any technical questions along the way."
    },
    {
        icon: <SpeakerIcon />,
        text: "Revi Marketing",
        tipimg: [],
        tiptext: "Revi Marketing",
        tiptext02: "Engage directly with your customer list through personalized and automated text messaging campaigns to drive more sales for your business, as well as promote new menu items, events, and more!"
    },
    {
        icon: <QRCodeIcon />,
        text: "Revi QR Code Integration",
        tipimg: [img05],
        tiptext: "Revi QR Code Integration",
        tiptext02: "Connect your customers directly to purchase from your online store through posters, delivery flyers, coasters and table tents."
    },
    {
        icon: <DeliveryIcon />,
        text: "Revi Delivery",
        tipimg: [],
        tiptext: "Revi Delivery",
        tiptext02: "0% commissions for online ordering(Delivery, Pickup, QR Codes) flat fee delivery vs 30% with Doordash."
    },
    {
        icon: <GiftIcon />,
        text: "Revi Rewards and Loyalty",
        tipimg: [img06],
        tiptext: "Revi Rewards and Loyalty",
        tiptext02: "Build a customer loyalty program straight from your Revi Dashboard and your customers can earn Revi points for more than just purchases to help increase repeat visits!"
    }
]

export const dataOfFinalSubmission = [
    {
        cssClassName: "stepOne",
        dataHeader: "Let's Dive In",
        dataPararaph: "Our introduction call will tailor your onboarding journey.We're here to help support you and your business goals.",
        scheduleCallButton: true
    },
    {
        cssClassName: "stepTwo",
        dataHeader: "Tech Magic, Simplified",
        dataPararaph: "Our tech wizards will seamlessly integrate Revi's hardware - Say hello to your new intuitive systems. Amazing technology without the stress!",
        scheduleCallButton: false
    },
    {
        cssClassName: "stepThree",
        dataHeader: "Unleash Your Inner Pro",
        dataPararaph: "Learn by doing! Dive into Revi's features with our Onboarding Specialists. Their goal is to boost your confidence, and optimize your workflow.",
        scheduleCallButton: false
    },
    {
        cssClassName: "stepFour",
        dataHeader: "The Big Launch Day",
        dataPararaph: "We're here to support your spectacular launch. Have questions? We're just a message away. Get ready to dazzle, Revi-style!",
        scheduleCallButton: false
    },
]

export const dataOfAllBusinessType = [
    {
        icon: <QuickIcon />,
        passValue: 'quick_service',
        text: "Quick Service",
        businessSelected: false
    },
    {
        icon: <FoodTruckIcon />,
        passValue: 'food_truck',
        text: "Food Truck",
        businessSelected: false
    },
    {
        icon: <CafeIcon />,
        passValue: 'quick_service',
        text: "Cafe",
        businessSelected: false
    },
    {
        icon: <AddLargeIcon />,
        passValue: 'other',
        text: "Other",
        businessSelected: false
    }
]

export const dataOfAverageCustomerCome = [
    {
        showvalue: "10-25",
        passvalue: "10-25",
    },
    {
        showvalue: "25-50",
        passvalue: "25-50",
    },
    {
        showvalue: "50-100",
        passvalue: "50-100",
    },
    {
        showvalue: "100-150",
        passvalue: "100-150",
    },
    {
        showvalue: "150+",
        passvalue: "150-150",
    },
]

export const dataOfAverageCustomerSpend = [
    {
        showvalue: "5-10",
        passvalue: "5-10"
    },
    {
        showvalue: "10-15",
        passvalue: "10-15"
    },
    {
        showvalue: "15-20",
        passvalue: "15-20"
    },
    {
        showvalue: "20-25",
        passvalue: "20-25"
    },
    {
        showvalue: "25+",
        passvalue: "25-25"
    }
]